<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>

         <v-row dense>
            <v-col cols="12" md="3" sm="6" v-for="resolution in resolutions" :key="resolution.id">
               <v-card class="resolution-card" dark>
                  <v-img
                     v-if="thumbnailUrl(resolution)"
                     :src="thumbnailUrl(resolution)"
                     height="170"
                     cover
                  ></v-img>
                  <div v-else class="resolution-placeholder">
                     <v-icon size="64" color="white">mdi-file-document-outline</v-icon>
                  </div>

                  <v-card-title class="subtitle-1 font-weight-bold">
                     {{ resolution.title }}
                  </v-card-title>
                  <v-card-text class="resolution-description">
                     {{ plainDescription(resolution.description) }}
                  </v-card-text>
                  <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn
                        v-if="resolutionUrl(resolution)"
                        icon
                        small
                        color="white"
                        :href="resolutionUrl(resolution)"
                        target="_blank"
                     >
                        <v-icon small>mdi-card-search</v-icon>
                     </v-btn>
                     <v-btn
                        v-if="documentUrl(resolution)"
                        icon
                        small
                        color="white"
                        :href="documentUrl(resolution)"
                        target="_blank"
                        download
                     >
                        <v-icon small>mdi-download</v-icon>
                     </v-btn>
                  </v-card-actions>
               </v-card>
            </v-col>

            <v-col cols="12" v-if="loading">
               <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </v-col>

            <v-col cols="12" v-if="!loading && resolutions.length === 0">
               <v-alert type="info" outlined>No resolutions available.</v-alert>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
const axios = require('axios')

export default {
   name: 'MOMResolutions',

   components: {
      DashboardLayout,
      BaseBreadcrumb,
   },

   data() {
      return {
         page: {
            title: 'Resolutions',
         },
         breadcrumbs: [
            {
               text: 'Dashboard',
               disabled: false,
               to: '/dashboard',
            },
            {
               text: 'Resolutions',
               disabled: true,
            },
         ],
         loading: false,
         resolutions: [],
      }
   },

   mounted() {
      this.loadResolutions()
   },

   methods: {
      loadResolutions() {
         this.loading = true
         axios.get('/member/api/agm/resolutions')
            .then((resp) => {
               var rtn = resp.data
               this.resolutions = rtn.status === 'OK' ? (rtn.data || []) : []
            })
            .catch(() => {
               this.resolutions = []
            })
            .finally(() => {
               this.loading = false
            })
      },

      documentUrl(item) {
         if (!item.document || !item.documentpath) {
            return null
         }
         return '/' + String(item.documentpath).replace(/^\/+|\/+$/g, '') + '/' + item.document
      },

      thumbnailUrl(item) {
         if (!item.thumbnail || !item.thumbnailpath) {
            return null
         }
         return '/' + String(item.thumbnailpath).replace(/^\/+|\/+$/g, '') + '/' + item.thumbnail
      },

      externalUrl(html) {
         if (!html) {
            return null
         }
         var match = String(html).match(/href=["']([^"']+)["']/i)
         return match ? match[1] : null
      },

      resolutionUrl(item) {
         return this.documentUrl(item) || this.externalUrl(item.description)
      },

      plainDescription(value) {
         if (!value) {
            return ''
         }
         var holder = document.createElement('div')
         holder.innerHTML = value
         return holder.textContent || holder.innerText || ''
      },
   },
}
</script>

<style scoped>
.resolution-card {
   background: #174ea6;
   min-height: 275px;
}

.resolution-placeholder {
   align-items: center;
   background: #174ea6;
   display: flex;
   height: 170px;
   justify-content: center;
}

.resolution-description {
   color: #4fa3ff;
   min-height: 50px;
   word-break: break-word;
}
</style>
